
import React, { useState } from 'react';
import './TipModal.css';
import { useApp } from '../../context/AppContext';

interface TipModalProps {
  onClose: () => void;
}

const TipModal: React.FC<TipModalProps> = ({ onClose }) => {
  const { adminUser, tipCreator } = useApp();
  const [amount, setAmount] = useState(5);
  const [customAmount, setCustomAmount] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const presetAmounts = [5, 10, 25, 50, 100];

  const handleSend = () => {
    const tipAmount = customAmount ? parseFloat(customAmount) : amount;
    if (tipAmount > 0) {
      tipCreator(tipAmount);
      setSent(true);
      setTimeout(onClose, 2000);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="tip-modal animate-slide-up" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        
        {sent ? (
          <div className="tip-success">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h3>Tip Sent!</h3>
            <p>Thank you for supporting {adminUser.displayName}</p>
          </div>
        ) : (
          <>
            <div className="tip-header">
              <img src={adminUser.avatar} alt={adminUser.displayName} />
              <div>
                <h3>Send Tip</h3>
                <p>to {adminUser.displayName}</p>
              </div>
            </div>

            <div className="tip-amounts">
              {presetAmounts.map(amt => (
                <button
                  key={amt}
                  className={`tip-amount ${amount === amt && !customAmount ? 'active' : ''}`}
                  onClick={() => { setAmount(amt); setCustomAmount(''); }}
                >
                  ${amt}
                </button>
              ))}
            </div>

            <div className="custom-amount">
              <span className="currency">$</span>
              <input
                type="number"
                placeholder="Custom amount"
                value={customAmount}
                onChange={e => setCustomAmount(e.target.value)}
              />
            </div>

            <textarea
              className="tip-message"
              placeholder="Add a message (optional)"
              value={message}
              onChange={e => setMessage(e.target.value)}
              rows={3}
            />

            <button className="send-tip-btn" onClick={handleSend}>
              Send ${customAmount || amount} Tip via PayPal
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TipModal;
